import styled from 'styled-components'
import ProductRating from 'components/Pages/Wine/View/Common/ProductRating'
import { useProduct } from '../../_methods'

const Wrapper = styled.div`
  grid-area: product-rating;
`

const AppellationRatings = () => {
  const product = useProduct()

  const ratings = product?.appellationRatings ?? []
  if (ratings.length === 0) return null

  return (
    <Wrapper>
      <ProductRating product={product} />
    </Wrapper>
  )
}

export default AppellationRatings
